import React from "react";

export default function TNC(props) {

    return (
        <>
            {/* <p className="yg_tnc">
                {props.tnc}
            </p> */}
            <p className="yg_tnc tncbox">
                <a href="/privacy-policy" target="_blank">
                    By clicking "Submit", I accept the T&amp;C of Motilal
                    Oswal AMC and agree to receive alerts &amp; notification
                    via Motilal Oswal AMC SMS, Email and Business Whatsapp
                    Account services.
                    </a>
            </p>
        </>
    );

}
